export default __webpack_public_path__ + "static/BG2-863702ba422ef5ceb0d49ba0f417ea70.jpg";